// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import FullScreen from './common/FullScreen'
import Title from './common/Title'
import LeftMenu from './common/LeftMenu'
import Header from './components/ProductSolutions/Header.vue'
import ContactUs from '@/components/ContactUs'
import router from './router'
import VueI18n from 'vue-i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import getElementUi from './plugins'
import VueAnimateNumber from 'vue-animate-number'
// import 'animate.css'
import animated from 'animate.css'
import './util/rem'
// import 'lib-flexible'
/* swiper */
import 'swiper/dist/css/swiper.min.css'
import './assets/icon/iconfont.css'
// import { Select, Option, Breadcrumb, BreadcrumbItem, Tabs, TabPane, Pagination, Dialog } from 'element-ui'
Vue.component('FullScreen', FullScreen)
Vue.component('ContactUs', ContactUs)
Vue.component('LeftMenu', LeftMenu)
Vue.component('Title', Title)
Vue.component('Header', Header)
Vue.use(VueI18n) // 通过插件的形式挂载
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
Vue.use(getElementUi)
Vue.use(VueAnimateNumber)
Vue.use(animated)
Vue.config.productionTip = false
const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || 'zh-cn', // 语言标识
  messages: {
    'zh-cn': require('./i18n/langs/zh-cn'), // 中文语言包
    'zh-hk': require('./i18n/langs/zh-hk'), // 中文语言包
    'en-us': require('./i18n/langs/en') // 英文语言包
  }
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: { App, FullScreen, LeftMenu },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js